import EmailVerifiedSvg from "./email-verified.svg";

export const EmailVerified = () => {
  return <EmailVerifiedSvg />;
};
